import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/features/home/views/Home.vue'
import axios from "axios";
import ForumSection from '@/features/forum/views/section/ForumSection.vue';
import NewThreadForm from '@/features/forum/views/thread/NewThreadForm.vue'
import { hasModernPreviewAccess } from '@/shells/models/modernPreviewAccess'
import { forumNextRoutes } from '@/features/forum-next/routes'

Vue.use(VueRouter)

const routes = [
    ...forumNextRoutes(requireModernPreviewAccess),
    {
        path: '/app',
        name: 'Landing',
        beforeEnter: checkLogged
    },
    {
        path: '/app/login',
        name: 'Login',
        meta: { appShell: 'bare' },
        component: () =>
            import('@/features/account/views/Login.vue'),
    },
    {
        path: '/app/vuelve-promo',
        redirect: '/app/graficador-dinamico'
    },
    {
        path: '/app/home',
        name: 'Home',
        component: Home,
    },
    {
        path: '/app/store',
        name: 'Marketplace',
        component: () =>
            import('@/features/commerce/views/Store.vue')
    },
    {
        path: '/app/graficador-dinamico',
        component: () =>
            import('@/features/stockchart/views/Base.vue'),
        children: [{
            path: '',
            name: 'Stockchart',
            component: () =>
                import('@/features/stockchart/views/Stockchart.vue'),
        },
        {
            path: 'stockchart-table',
            name: 'StockchartTable',
            component: () =>
                import('@/features/stockchart/views/Stockchart.vue'),
        }
        ],
    },
    {
        path: '/app/graficador-next',
        name: 'ChartingNext',
        meta: { appShell: 'modern', documentTitle: 'Graficador | Eurekers' },
        beforeEnter: requireModernPreviewAccess,
        component: () =>
            import('@/features/charting-next/views/ChartingWorkspacePage.vue')
    },
    {
        path: '/app/graficador-next/:entryType/:entryValue?',
        name: 'ChartingNextEntry',
        meta: { appShell: 'modern', documentTitle: 'Graficador | Eurekers' },
        beforeEnter: requireModernPreviewAccess,
        component: () =>
            import('@/features/charting-next/views/ChartingWorkspacePage.vue')
    },
    {
        path: '/app/informes-next',
        name: 'ReportsNext',
        meta: { appShell: 'modern', documentTitle: 'Informes | Eurekers' },
        beforeEnter: requireModernPreviewAccess,
        component: () =>
            import('@/features/informes-next/views/ReportsPage.vue')
    },
    {
        path: '/app/informes-next/:slug',
        name: 'ReportNext',
        meta: { appShell: 'modern', documentTitle: 'Informes | Eurekers' },
        beforeEnter: requireModernPreviewAccess,
        component: () =>
            import('@/features/informes-next/views/ReportPage.vue')
    },
    {
        path: '/app/proximas-ipos',
        name: 'UpcomingIpos',
        meta: { appShell: 'modern', documentTitle: 'Próximas IPOs | Eurekers' },
        beforeEnter: requireModernPreviewAccess,
        component: () =>
            import('@/features/upcoming-ipos/views/UpcomingIposPage.vue')
    },
    {
        path: '/app/graficador-dinamico/:param1',
        component: () =>
            import('@/features/stockchart/views/Base.vue'),
        children: [{
            path: '',
            name: 'Stockchart',
            component: () =>
                import('@/features/stockchart/views/Stockchart.vue'),
        },
        {
            path: 'stockchart-table',
            name: 'StockchartTable',
            component: () =>
                import('@/features/stockchart/views/Stockchart.vue'),
        }
        ],
    },
    {
        path: '/app/graficador-dinamico/:param1/:param2',
        component: () =>
            import('@/features/stockchart/views/Base.vue'),
        children: [{
            path: '',
            name: 'Stockchart',
            component: () =>
                import('@/features/stockchart/views/Stockchart.vue'),
        },
        {
            path: 'stockchart-table',
            name: 'StockchartTable',
            component: () =>
                import('@/features/stockchart/views/Stockchart.vue'),
        }
        ],
    },
    {
        path: '/app/portfolio',
        name: 'Portfolio',
        beforeEnter: requirePortfolioAccess,
        component: () =>
            import('@/features/portfolio/current/PortfolioManager.vue')
    }, {
        path: '/app/portfolio/:param1/:param2',
        name: 'Portfolio',
        beforeEnter: requirePortfolioAccess,
        component: () =>
            import('@/features/portfolio/legacy/views/Portfolio.vue')
    }, {
        path: '/app/artificial-inteligence',
        name: 'InteligenceArtificial',
        component: () =>
            import('@/features/market-tools/views/InteligenceArtificial.vue')
    }, {
        path: '/app/twinsouls',
        name: 'TwinSouls',
        component: () =>
            import('@/features/market-tools/views/TwinSouls.vue')
    }, {
        path: '/app/directionality',
        name: 'Directionality',
        component: () =>
        import ('@/features/directionality/views/Directionality.vue')
    },  {
        path: '/app/stoploss',
        name: 'StopLoss',
        component: () =>
            import('@/features/market-tools/views/StopLoss.vue')
    }, {
        path: '/app/risk',
        name: 'Risk',
        component: () =>
            import('@/features/market-tools/views/Risk.vue')
    }, {
        path: '/app/widgets',
        name: 'Widgets',
        component: () =>
            import('@/features/widgets/views/Widgets.vue')
    }, {
        path: '/app/ejercicios',
        name: 'ExercisesNext',
        meta: { appShell: 'modern', documentTitle: 'Ejercicios | Eurekers' },
        beforeEnter: requireModernPreviewAccess,
        component: () =>
            import('@/features/exercises-next/views/ExercisesNextPage.vue')
    }, {
        path: '/app/ejercicios/:type/:subtype',
        name: 'ExercisesNextSession',
        meta: { appShell: 'modern', documentTitle: 'Ejercicio | Eurekers' },
        beforeEnter: requireModernPreviewAccess,
        component: () =>
            import('@/features/exercises-next/views/ExerciseSessionPage.vue')
    }, {
        path: '/app/exercises',
        name: 'Exercises',
        component: () =>
            import('@/features/education/views/Exercises.vue')
    }, {
        path: '/app/courses',
        name: 'Courses',
        component: () =>
            import('@/features/education/views/Courses.vue')
    }, {
        path: '/app/help-center',
        name: 'HelpCenter',
        component: () =>
            import('@/features/support/views/HelpCenter.vue')
    }, {
        path: '/app/broker-simulator',
        name: 'BrokerSimulator',
        component: () =>
            import('@/features/market-tools/views/BrokerSimulator.vue')
    }, {
        path: '/app/pricing',
        name: 'Pricing',
        component: () =>
            import('@/features/commerce/views/Store.vue')
    }, {
        path: '/app/preferences',
        name: 'Preferences',
        component: () =>
            import('@/features/account/views/Preferences.vue')
    }, {
        path: '/app/InvestmentCalculator',
        name: 'InvestmentCalculator',
        component: () =>
            import('@/features/calculators/views/InvestmentCalculator.vue')
    },     {
        path: '/app/my-profile',
        name: 'MyProfile',
        component: () =>
            import('@/features/account/views/MyProfile.vue')
    },
    {
        path: '/app/referrals',
        name: 'Referrals',
        beforeEnter: requireActiveRole,
        component: () =>
            import('@/features/account/views/Referrals.vue')
    },
    {
        path: '/app/change-password',
        name: 'Password',
        component: () =>
            import('@/features/account/views/Password.vue')
    },
    {
        path: '/app/retrieve-password',
        name: 'Password',
        component: () =>
            import('@/features/account/views/RetrievePassword.vue')
    },
    {
        path: '/app/compoundInterestCalculator',
        name: 'Calculadora de interés compuesto',
        component: () =>
            import('@/features/calculators/views/CompoundInterestCalculator.vue')
    },
    {
        path: '/app/calculadora-autonomia-financiera',
        name: 'Calculadora de autonomía financiera',
        component: () =>
            import('@/features/calculators/views/RetirementCalculator.vue')
    },
    {
        path: '/app/inflationCalculator',
        name: 'Calculadora de inflación',
        component: () =>
            import('@/features/calculators/views/InflationCalculator.vue')
    },
    {
        path: '/app/calculadora-creador-cartera',
        name: 'Calculadora de cartera',
        component: () =>
            import('@/features/calculators/views/PortfolioCreatorCalculator.vue')
    }, {
        path: '/app/store',
        name: 'Tienda',
        component: () =>
            import('@/features/commerce/views/Store.vue')
    }, {
        path: '/app/cart',
        name: 'Cesta',
        component: () =>
            import('@/features/commerce/views/Cart.vue')
    }, {
        path: '/app/stock/:ticker',
        name: 'Valores',
        component: () =>
            import('@/features/market-tools/views/Valores.vue')
    }, {
        path: '/app/portfolio/invest-preferences',
        name: 'InvestPreferences',
        beforeEnter: requirePortfolioAccess,
        component: () =>
            import('@/features/portfolio/legacy/views/Portfolio_preferences.vue')
    }, {
        path: '/app/portfolio/balance/:idc',
        name: 'Portfolio Balance',
        beforeEnter: requirePortfolioAccess,
        component: () =>
            import('@/features/portfolio/legacy/views/Portfolio_balance.vue')
    }, {
        path: '/app/portfolio/historic/:idc',
        name: 'Portfolio Historic',
        beforeEnter: requirePortfolioAccess,
        component: () =>
            import('@/features/portfolio/legacy/views/Portfolio_historic.vue')
    }, {
        path: '/app/portfolio/general/:idc',
        name: 'Portfolio General',
        beforeEnter: requirePortfolioAccess,
        component: () =>
            import('@/features/portfolio/legacy/views/Portfolio_general.vue')
    }, {
        path: '/app/portfolio/wait-list/:idc',
        name: 'Portfolio WaitList',
        beforeEnter: requirePortfolioAccess,
        component: () =>
            import('@/features/portfolio/legacy/views/Portfolio_waitlist.vue')
    }, {
        path: '/app/portfolio/open-positions/:idc',
        name: 'Portfolio open Positions',
        beforeEnter: requirePortfolioAccess,
        component: () =>
            import('@/features/portfolio/legacy/views/Portfolio_openpositions.vue')
    }, {
        path: '/app/portfolio-access-denied',
        name: 'PortfolioAccessDenied',
        beforeEnter: requireAuth,
        component: () =>
            import('@/features/portfolio/views/PortfolioAccessDenied.vue')
    }, {
        path: '/app/videos',
        name: 'Videos',
        component: () =>
            import('@/features/education/views/Videos.vue')
    }, {
        path: '/app/profile/certificates/:uid?',
        name: 'UserCertificates',
        component: () =>
            import('@/features/account/views/Certificates.vue')
    }, {
        path: '/app/profile/user-photo',
        name: 'UserPhoto',
        component: () =>
            import('@/features/account/views/User-photo.vue')
    }, {
        path: '/app/profile/bills',
        name: 'UserBills',
        component: () =>
            import('@/features/account/views/Bills.vue')
    }, {
        path: '/app/nuevas-ipos',
        name: 'NewsIPOs',
        component: () =>
            import('@/features/market-tools/views/News_ipos.vue')
    }, {
        path: '/app/crear-notificacion',
        name: 'CrearNotificacion',
        beforeEnter: checkAdminRights,
        component: () =>
            import('@/features/admin/views/Crear_notificacion.vue')
    }, {
        path: '/app/session-control',
        name: 'SessionControl',
        beforeEnter: checkAdminRights,
        component: () =>
            import('@/features/admin/views/Session_control.vue')
    }, {
        path: '/app/adminmenu',
        name: 'AdminMenu',
        beforeEnter: checkAdminRights,
        component: () =>
            import('@/features/admin/views/AdminMenu.vue')
    }, {
        path: '/app/eventos',
        name: 'Eventos',
        beforeEnter: checkAdminRights,
        component: () =>
            import('@/features/admin/views/Eventos.vue')
    }, {
        path: '/app/mentorias',
        redirect: '/app/home'
    }, {
        path: '/app/mentorias/admin',
        redirect: '/app/home'
    }, {
        path: '/app/curso-online/login',
        name: 'Login Curso Online',
        component: () =>
            import('@/features/account/views/FakeLoginToCO.vue')
    }, {
        path: '/app/eurekers-school',
        name: 'Eurekers School',
        component: () =>
            import('@/features/education/views/EurekersSchool.vue')
    }, {
        path: '/app/user-register',
        name: 'Registro de Usuario',
        component: () =>
            import('@/features/account/views/RegisterForm.vue')
    }, {
        path: '/app/account-verification',
        name: 'Verificación de Cuenta',
        component: () =>
            import('@/features/account/views/AccountVerification.vue')
    }, {
        path: '/app/product-confirmation/gracias',
        name: 'Confirmacion de compra',
        component: () =>
            import('@/features/commerce/views/ProductConfirmation.vue')
    },
    {
        path: '/app/product-confirmation/error',
        name: 'Error de compra',
        component: () =>
            import('@/features/commerce/views/ProductConfirmationError.vue')
    },
    {
        path: '/app/course/register',
        name: 'Promo',
        component: () =>
            import('@/features/education/views/Promo.vue')
    },
    {
        path: '/app/store/course/form-waitlist/:country',
        name: 'Form Waitlist Courses',
        component: () =>
            import('@/features/education/views/Form_waitlist_courses.vue')
    },
    {
        path: '/app/informe/register',
        name: 'InformeFlow',
        component: () =>
            import('@/features/informes/views/InformeFlow.vue')
    },
    {
        path: '/app/informe/subscribe',
        name: 'InformeSubscribe',
        component: () =>
            import('@/features/informes/views/InformeSubscribe.vue')
    },
    {
         path: '/app/informes',
         name: 'informes',
         component: () => import('@/features/informes/views/InformeMain.vue'),
         meta: {
             requiresAuth: true
         }
    },
    {
        path: '/app/noticias-flash/admin',
        name: 'NewsflashAdmin',
        beforeEnter: requireNewsflashManagementAccess,
        component: () => import('@/features/newsflash/views/NewsflashAdmin.vue')
    },
    {
        path: '/app/noticias-flash/admin/queue/:id',
        name: 'NewsflashAdminQueueDetail',
        beforeEnter: requireNewsflashManagementAccess,
        component: () => import('@/features/newsflash/views/NewsflashAdmin.vue')
    },
    {
        path: '/app/noticias-flash/admin/ja/batch',
        name: 'NewsflashAdminJaBatchReview',
        beforeEnter: requireNewsflashManagementAccess,
        component: () => import('@/features/newsflash/views/NewsflashJaBatchReview.vue'),
        meta: {
            hideAppMenu: true
        }
    },
    {
        path: '/app/noticias-flash/admin/ja/publicada/:slug',
        name: 'NewsflashAdminJaPublished',
        beforeEnter: requireNewsflashManagementAccess,
        component: () => import('@/features/newsflash/views/NewsflashJaPublished.vue'),
        meta: {
            hideAppMenu: true
        }
    },
    {
        path: '/app/noticias-flash/admin/ja/:id',
        name: 'NewsflashAdminJaReview',
        beforeEnter: requireNewsflashManagementAccess,
        component: () => import('@/features/newsflash/views/NewsflashAdmin.vue')
    },
    {
        path: '/app/noticias-flash/:slug?',
        name: 'NoticiasFlash',
        beforeEnter: requireNewsflashPublicAccess,
        component: () => import('@/features/newsflash/views/NoticiasFlash.vue')
    },
    {
        path: '/app/informe/last',
        name: 'informe-last',
        beforeEnter: redirectToLastInforme,
        component: () => import('@/features/informes/views/InformeDetail.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/app/informe/:title',
        name: 'informe-detail',
        component: () => import('@/features/informes/views/InformeDetail.vue'),
        meta: {
            requiresAuth: true
        },
    },
    {
        path: '/app/libros-de-bolsa',
        name: 'LibrosBolsa',
        component: () =>
        import ('@/features/education/views/LibrosBolsa.vue')
    },
    {
        path: '/app/activo-resumen',
        name: 'LastMasterclass',
        beforeEnter: requireAuth,
        component: () =>
        import('@/features/education/views/LastMasterclass.vue')
    },
    {
        path: '/app/oldforum',
        name: 'OldForum',
        component: () =>
        import ('@/features/forum/views/legacy/Foro.vue')
    },
    {
        path: '/app/forum',
        name: 'Forum',
        beforeEnter: requireActiveRole,
        component: () =>
        import ('@/features/forum/views/index/NewForum.vue')
    },
    {
        path: '/app/forum/rules',
        name: 'ForumRules',
        beforeEnter: requireActiveRole,
        component: () =>
        import ('@/features/forum/views/ForumRules.vue')
    },
    {
        path: '/app/forum/section/:slug',
        name: 'ForumSection',
        beforeEnter: requireActiveRole,
        component: ForumSection
    },
    {
        path: '/app/forum/thread/:nid',
        name: 'ForumThread',
        beforeEnter: requireActiveRole,
        component: () =>
        import ('@/features/forum/views/thread/ForumThread.vue')
    },
    {
        path: '/app/forum/search',
        name: 'ForumSearch',
        beforeEnter: requireActiveRole,
        component: () =>
        import ('@/features/forum/views/ForumSearch.vue')
    },
    {
        path: '/app/forum/new-thread',
        name: 'ForumNewThread',
        beforeEnter: requireActiveRole,
        component: NewThreadForm
    },
    {
    path: '/app/forum/user/activity',
    name: 'UserActivity',
    beforeEnter: requireActiveRole,
    component: () => import('@/features/forum/views/user/UserActivity.vue')
  },
  {
    path: '/app/forum/admin/need-response',
    name: 'AdminNeedResponse',
    beforeEnter: requireModernPreviewAccess,
    component: () => import('@/features/forum/views/admin/AdminNeedResponse.vue'),
    meta: {
      requiresAuth: true,
      requiresAdmin: true
    }
  },
  {
    path: '/app/forum/admin/reports',
    name: 'AdminReports',
    beforeEnter: requireModernPreviewAccess,
    component: () => import('@/features/forum/views/admin/AdminReports.vue'),
    meta: {
      requiresAuth: true,
      requiresAdmin: true
    }
  },
  {
    path: '/app/forum/admin',
    name: 'AdminPanel',
    beforeEnter: requireModernPreviewAccess,
    component: () => import('@/features/forum/views/admin/AdminPanel.vue'),
    meta: {
      requiresAuth: true,
      requiresAdmin: true
    }
  }
]

const router = new VueRouter({
    mode: 'history',
    routes
})
async function checkAdminRights(to, from, next) {
    let isAdmin = await _getUserInfo();
    isAdmin = isAdmin.data.is_developer_user;
    if (isAdmin) {
        next();
    } else {
        next({ path: '/app/graficador-dinamico' });
    }
}

async function checkLogged(to, from, next) {
    let isLogged = await _getUserInfo();
    //Esta comprobacion hace string con numero y da true cuando no debe por ser !== en vez de !=, por que lo sepas
    //No lo cambio porque tiene que ver con el login y el login va bien. Asi que asi se queda.
    isLogged = isLogged.data.uid !== 0;
    if (isLogged) {
        next({ path: '/app/login' });
    } else {
        next({ path: '/app/graficador-dinamico' });
    }
}

async function requireAuth(to, from, next) {
    try {
        let user = await _getUserInfo();
        let isLogged = user.data && user.data.uid && user.data.uid != 0;
        if (isLogged) {
            next();
        } else {
            next({ 
                path: '/app/login',
                query: { redirect: to.fullPath }
            });
        }
    } catch (error) {
        next({ 
            path: '/app/login',
            query: { redirect: to.fullPath }
        });
    }
}

async function requireModernPreviewAccess(to, from, next) {
    try {
        const response = await _getUserInfo();
        const user = response.data || {};
        const isLogged = user.uid && user.uid != 0;

        if (!isLogged) {
            next({
                path: '/app/login',
                query: { redirect: to.fullPath }
            });
            return;
        }

        if (hasModernPreviewAccess(user)) {
            next();
        } else {
            next({ path: '/app/graficador-dinamico' });
        }
    } catch (error) {
        next({
            path: '/app/login',
            query: { redirect: to.fullPath }
        });
    }
}

async function requirePortfolioAccess(to, from, next) {
    try {
        let user = await _getUserInfo();
        let isLogged = user.data && user.data.uid && user.data.uid != 0;
        if (!isLogged) {
            next({ 
                path: '/app/login',
                query: { redirect: to.fullPath }
            });
            return;
        }

        if (user.data && user.data.is_basic_user) {
            next({ path: '/app/portfolio-access-denied' });
            return;
        }

        next();
    } catch (error) {
        next({ 
            path: '/app/login',
            query: { redirect: to.fullPath }
        });
    }
}

async function requireNewsflashAdmin(to, from, next) {
    try {
        let user = await _getUserInfo();
        let isLogged = user.data && user.data.uid && user.data.uid != 0;
        if (!isLogged) {
            next({
                path: '/app/login',
                query: { redirect: to.fullPath }
            });
            return;
        }

        let hasAdminAccess = !!(user.data.is_admin_user || user.data.is_developer_user);
        if (hasAdminAccess) {
            next();
        } else {
            next({ path: '/app/informes' });
        }
    } catch (error) {
        next({
            path: '/app/login',
            query: { redirect: to.fullPath }
        });
    }
}

async function requireNewsflashManagementAccess(to, from, next) {
    const hasUrlKey = !!(to.query && to.query.k);
    const hasStoredKey = !!window.sessionStorage.getItem('newsflash_ai_access_key');

    if (hasUrlKey || hasStoredKey) {
        next();
        return;
    }

    return requireNewsflashAdmin(to, from, next);
}

async function requireNewsflashPublicAccess(to, from, next) {
    try {
        const response = await axios.get(`${process.env.VUE_APP_API}/adminmenu/newsflash-public-access-setting`);
        const publicAccessEnabled = response.data && response.data.success
            ? parseInt(response.data.value) === 1
            : false;

        if (publicAccessEnabled) {
            return requireActiveRole(to, from, next);
        }
    } catch (error) {
        return requireNewsflashAdmin(to, from, next);
    }

    return requireNewsflashAdmin(to, from, next);
}

async function requireActiveRole(to, from, next) {
    try {
        let user = await _getUserInfo();
        let isLogged = user.data && user.data.uid && user.data.uid != 0;
        if (!isLogged) {
            next({ 
                path: '/app/login',
                query: { redirect: to.fullPath }
            });
            return;
        }

        // Check if referrals is enabled for that route
        if (to.name === 'Referrals') {
            try {
                const settings = await _getReferralsSettings();
                if (!settings.data.enabled) {
                    next({ path: '/app' });
                    return;
                }
            } catch (err) {
                console.error('Error checking referrals settings', err);
                // Fallthrough to role check if check fails (or deny? deny is safer but maybe disruptive if api fails)
                // Let's deny if we can't verify it's enabled
                next({ path: '/app' });
                return;
            }
        }
        
        if (hasActiveRoleAccess(user.data)) {
            next();
        } else {
            next({ path: '/app/store' }); // Redirect to store to upgrade plan
        }
    } catch (error) {
        next({ path: '/app/login' });
    }
}

function hasActiveRoleAccess(userData) {
    if (!userData) {
        return false;
    }

    return !!(
        userData.is_admin_user ||
        userData.is_developer_user ||
        userData.is_bronze_user ||
        userData.is_silver_user ||
        userData.is_gold_user ||
        userData.is_platinum_user ||
        userData.is_pre_eureker_user ||
        userData.is_pre_user ||
        userData.is_basic_user ||
        userData.is_basico_asiste_avanzado
    );
}

async function redirectToLastInforme(to, from, next) {
    try {
        const { data } = await axios.get(`${process.env.VUE_APP_API}/api/informes-list`);
        const informes = Array.isArray(data) ? data : [];

        if (!informes.length) {
            next({ path: '/app/informes' });
            return;
        }

        const latestInforme = informes.reduce((latest, current) => {
            const latestDate = _getInformeDate(latest);
            const currentDate = _getInformeDate(current);

            if (!currentDate && !latestDate) {
                return latest || current;
            }

            if (!latestDate) {
                return current;
            }

            if (!currentDate) {
                return latest;
            }

            return currentDate > latestDate ? current : latest;
        }, null);

        const targetInforme = latestInforme || informes[0];
        const slug = _buildInformeSlug(targetInforme);

        if (!slug) {
            next({ path: '/app/informes' });
            return;
        }

        next({
            path: `/app/informe/${slug}`,
            query: to.query,
            hash: to.hash
        });
    } catch (error) {
        next({ path: '/app/informes' });
    }
}

function _getInformeDate(informe) {
    if (!informe) {
        return null;
    }

    if (informe.created) {
        const createdDate = new Date(informe.created);
        if (!isNaN(createdDate.getTime())) {
            return createdDate;
        }
    }

    const title = typeof informe.title === 'string' ? informe.title : '';
    const match = title.match(/(\d{1,2})\/(\d{1,2})\/(\d{4})/);

    if (match) {
        const day = parseInt(match[1], 10);
        const month = parseInt(match[2], 10) - 1;
        const year = parseInt(match[3], 10);
        const date = new Date(year, month, day);
        if (!isNaN(date.getTime())) {
            return date;
        }
    }

    return null;
}

function _buildInformeSlug(informe) {
    if (!informe || typeof informe.title !== 'string') {
        return null;
    }

    const parts = informe.title.split('/');
    if (parts.length === 3) {
        return encodeURIComponent(`${parts[0]}-${parts[1]}-${parts[2]}`);
    }

    return encodeURIComponent(informe.title);
}

function _getUserInfo() {
    const uid = localStorage.getItem("uid") || 0;
    return axios.get(process.env.VUE_APP_API + "/api/v1/users/user-attributes/" + uid);
}

function _getReferralsSettings() {
    return axios.get(process.env.VUE_APP_API + "/api/v1/referrals/settings");
}
export default router
